const newsletterBanner = document.querySelector('.newsletter-banner');

if (newsletterBanner) {
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.target.classList.contains('show-thankyou')) {
        newsletterBanner.classList.add('is-sent');

        const inputValue = newsletterBanner.querySelector('.mod-input__field').value;
        newsletterBanner.querySelector('.newsletter-banner__right-sent__email').textContent = inputValue;
      }
    });
  });

  observer.observe(newsletterBanner.querySelector('.form-component'), { attributes: true });
}
